class NewTemplateComponent {
  constructor(TBService, AuthService, SchemaService, TemplateService, $state, $scope) {
    'ngInject';
    this.tb = TBService;
    this.as = AuthService;
    this.ss = SchemaService;
    this.ts = TemplateService;
    this.$state = $state;
    this.$scope = $scope;

    this.validConnection = undefined;
    this.connectionSelected = false;
    this.template = {
      type: "static",
      title: "",
      originalDocument: "",
      pages: [],
      references: [],
      tokens: [],
      behaviors: [],
      conditions: [],
      relations: []
    };
    this.messages = [];
    this.creating = false;
    this.loading = "Finding Connections..."
    this.acceptedFormats = {
      'static': ".pdf,.jpg,.jpeg,.doc,.docx,.ppt,.pptx,.png",
      'dynamic': ".doc,.docx"
    };
  }

  async $onInit() {
    const [PROVIDER, { "claims": { provider, realm } }] = await Promise.all([
      this.as.getProviderSettings(),
      this.as.idToken()
    ]);
    this.PROVIDER = PROVIDER;

    this.template = { ...this.template, provider, realm };
    if (!PROVIDER.handleAppsIndependently) {
      this.template.appId = "Global";
      this.validConnection = true;
    }

    const watchConnection = this.$scope.$watch(`$ctrl.validConnection`, (newVal, oldVal) => {
      if (newVal && newVal != oldVal) {
        angular.element("#expandTemplate").trigger("click");
      }
    });
    this.$scope.$on('$destroy', () => { watchConnection() });
    this.loading = "";
  }

  setMsg(message, type, closeInSeconds) {
    this.messages.push({ message, 'class': type, closeInSeconds });
  }

  showApp() {
    return this.PROVIDER?.handleAppsIndependently;
  }

  close() {
    this.$close();
  }

  async handleFileSelected(rawFile, encFile) {
    this.loading = "Building Template...";
    this.creating = true;
    this.messages = [];

    const { name, type } = rawFile;
    const fileExt = name.split(".")[name.split(".").length - 1];

    this.template.originalDocument = {
      fileExt,
      fileName: name,
      body: encFile.body,
      mimeType: type
    };
    this.template.title = this.template.title || name.split(".")[0];

    this.loading = "";
    this.creating = false;
  }

  clearOriginalDoc() {
    this.template.originalDocument = "";
  }

  async postNewTemplate() {
    try {
      this.loading = "Creating Template";
      this.creating = true;
      const { template } = this;
      const promptValues = this.ts.getNewConnection();
      if (promptValues.length) {
        const connId = await this.ts.saveConnection(template, promptValues);
        template.connectionId = connId;
        this.ts.clearNewConnection();
      }
      template.folderId = this.ts.activeFolderId || '';

      const templateReq = { template };
      const response = await this.tb.newTemplate(templateReq);
      const { "data": { "template": { id } } } = response;

      const next = `app.${template.type === 'dynamic' ? 'dynamic' : 'template'}-builder`;
      this.$state.go(next, { 'templateId': id });

      this.$close();
    } catch (error) {
      console.error('ERROR', error);
      this.setMsg(error.message, "alert-danger");
    } finally {
      this.creating = false;
      this.loading = "";
      this.$scope.$apply();
    }
  }
}

export default {
  bindings: {
  },
  templateUrl: 'form-builder/new-template/new-template.component.html',
  controller: NewTemplateComponent
};